
import { useState, useEffect, useRef , useMemo,useCallback} from 'react';
import config from "../config/config";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import axios from "axios";
import { sharedData } from '../sharedData/sharedData';
import { propertyService } from "../requests/propertyService";
import { requestService } from "../requests/requestService";
import { clientCoutnerpartyService } from "../requests/clientCounterpartyService";
import { managementStructureService } from "../requests/managementStrcutureService";
import { ManagementStructureFactory } from "../factory/managementStrcutureFactory";
import { CorporateStructureFactory } from "../factory/corporateStructureFactory";
import { corporateStructureService } from "../requests/corporateStructureService";
import { ClientCounterpartyFactory } from "../factory/clientCoutnerpartyFactory";
import { PropertyFactory } from "../factory/propertyFactory";
import { userSession } from '../observers/userObserver';
import { fetchTransactions, fetchTransactionDetails, updateTransaction } from "../components/transactionapi";
import { TransactionFactory } from "../factory/transactionFactory";

import { diligenceObservable } from "../observers/deligenceObservable";

export const useFinalReview = () => {
  const [statuses, setStatuses] = useState({});
  const [requestId, setRequestId] = useState("");
  const [requestStatus, setRequestStatus] = useState("");
  const [isAllValidated, setIsAllValidated] = useState(false);

  const [requsetStatusType, setRequestStatusType] = useState("");

  const [canFinalize, setCanFinalize] = useState(false);
  const [requiredDocumentsAttached, setRequiredDocumentsAttached] = useState(false);
  const [isFinalCompleted, setisFinalCompleted] = useState(false);
  const [pagesValidated, setPagesValidated] = useState("Yes");
  const [signature, setSignature] = useState(null);
  const [uploadedSignature, setUploadedSignature] = useState(null);
  const [showSignatureContainer, setShowSignatureContainer] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [finalReviewInfo, setfinalReviewInfo] = useState({});
  const [MLNOFlag, setMLNOFlag] = useState("");
  const [formData, setFormData] = useState({
    justification: "",
    MLNOCOnsideration: "",
    mlnoComments: "",
    mlnoSignature: "",
    status: "",
  });
  const [diligenceLevel, setDiligenceLevel] = useState("");
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const token = userSession.getToken()


    const [isReadOnly, setIsReadOnly] = useState(
      searchParams.get("readonly") === "true" || searchParams.get("view") === "true"
    );


    const isView = useMemo(() => searchParams.get("view") === "true", [searchParams]);
    const isEdit = useMemo(() => searchParams.get("edit") === "true", [searchParams]);

    useEffect(() => {
      const isReadOnlyFromURL = searchParams.get("readonly") === "true";
      const isViewMode = searchParams.get("view") === "true";
      if (isReadOnlyFromURL || isViewMode) {
        setIsReadOnly(true);
      }
    }, [searchParams]);
    
  const [refreshDocs, setRefreshDocs] = useState(false);

  // Subscribe to diligence observable to get real-time updates
  useEffect(() => {
    const updateDiligenceLevel = () => {
      const finalDiligence = diligenceObservable.finalDiligence();
      if (finalDiligence && finalDiligence !== diligenceLevel) {
        setDiligenceLevel(finalDiligence);
      }
    };

    // Subscribe to observable changes
    const unsubscribe = diligenceObservable.subscribe(updateDiligenceLevel);

    // Set initial value
    updateDiligenceLevel();

    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      } else if (unsubscribe && typeof unsubscribe.unsubscribe === 'function') {
        unsubscribe.unsubscribe();
      }
    };
  }, [diligenceLevel]);


  const getStoredValues = () => {
    try {
      let entityId = sharedData.get("entityId") || null;
      let requestId = sharedData.get("requestId") || null;
      const email = userSession.getUserEmail() || null;
      return { entityId, requestId, email };
    } catch (error) {
      console.error("❌ Error retrieving stored values:", error);
      return { entityId: null, requestId: null, email: null };
    }
  };

  const getLoadedDocKeys = async () => {
    try {
      const pageName = window.location.pathname;
      const { entityId, requestId, email } = getStoredValues();  // Assuming getStoredValues is available

      const response = await axios.get(`${config['backend-url']}/documents`, {
        params: { page_name: pageName, entityId, requestId, email },
        headers: {
          Authorization: `Bearer ${userSession.getToken()}`, // Use token from userSession
        }
      });

      if (response.status === 200 && Array.isArray(response.data)) {
        console.log("response:", response);

        const docKeys = response.data.map(doc => {
          if (pageName === "/FinalReview" && doc.is_optional === false) {
              // const pageKey = doc.page_name?.startsWith("/") ? doc.page_name.substring(1) : doc.page_name || "unknown";
              // return `${pageKey}-${doc.document_type}`;
              return doc.document_type;
            } else {
              return doc.document_type;
            }
          });

          localStorage.setItem("loadedDocs", JSON.stringify(docKeys));
          console.log("localStorage after loaded:",localStorage)
          return docKeys;
        } else {
          return [];
        }
      } catch (error) {
        console.error("❌ Error fetching doc keys:", error);
        return [];
      }
    };

  
  const fetchPropertyDetailsByPropertyId = useCallback(async (propertyId)=>{
    if (!propertyId) return;
    try {
      const propertyDetails = await propertyService.fetchPropertyDetailsByPropertyId(propertyId);
      if (propertyDetails) {
          const updatedFormData = PropertyFactory(propertyDetails);
          localStorage.setItem("propertyFormData", JSON.stringify(updatedFormData));
          sharedData.set("propertyId", updatedFormData.propertyId);
          setFormData(updatedFormData);
         
      } else {
          console.warn("⚠️ No property details found in the response.");
      }
  } catch (error) {
      console.error("❌ Error fetching property details:", error);
  }
},[]);
  


    const getTransactionDetails = useCallback(async (transactionId) => {
      console.log("🔄 Fetching transaction details for ID:", transactionId);
      if (!transactionId) {        
        return;
      }
      try {
        const details = await fetchTransactionDetails(transactionId);
        if (details) {
          const updatedFormData = TransactionFactory(details);
          setFormData(updatedFormData);
          localStorage.setItem("transaction", JSON.stringify(updatedFormData));
          
        }
      } catch (error) {
        console.error("Error fetching transaction details:", error);
      }
    },[]);



    
      const getCorporateStrucutureByEntityId = useCallback(async (entityId) => {
        try {
          const response = await corporateStructureService.getCorporateStructure(entityId);
          if (response.ok) {
            const data = CorporateStructureFactory(response.data);
            setFormData(data);
            // updateUBOState(data.uboState);
            console.log("data inside getCorporateStrucutureByEntityId:",data)
           
    
            localStorage.setItem("corporateFormData", JSON.stringify(data));
          } else {
            console.error("Failed to fetch corporate structure data:", response.data);
          }
        } catch (error) {
          
          console.error("Error fetching corporate structure data:", error);
        }
      },[]);
    
      useEffect(()=>{
      
          getCorporateStrucutureByEntityId(sharedData.get("entityId"))
        
      },[getCorporateStrucutureByEntityId]);


    useEffect(()=>{
    
        getTransactionDetails(sharedData.get("transactionId"));
      
    },[getTransactionDetails]);
    useEffect(()=>{
     
        fetchPropertyDetailsByPropertyId(sharedData.get("propertyId"));
      
    },[fetchPropertyDetailsByPropertyId]);
  

    const getEntityDetailsByEntityId = useCallback(async (entityId) => {
      if (entityId !== "None") {
        const entityDetail = await clientCoutnerpartyService.fetchEntityDetailsByEntityId(entityId);
        if (entityDetail && entityDetail.details) {
          const formData = ClientCounterpartyFactory(entityId, entityDetail.details);
    
          localStorage.setItem("clientFormData", JSON.stringify(formData));
        }
      }
    }, []);

  useEffect(() => {
   
      getEntityDetailsByEntityId(sharedData.get("entityId"))
    
  }, [getEntityDetailsByEntityId]);


const getManagementStrcutureDetails = useCallback(async (entityId) => {
    try {
      const response = await managementStructureService.getManagementStrcutureByEntityId(entityId);
      if (response.ok) {
        const data = response.data;
        // console.log("Data: ", data[0].data);
        const managersData = ManagementStructureFactory(data[0].data);
        
        
        // No 'managersStatus' — see the note in useClientCounterpartyData. Final Review
        // reads its statuses from /get-all-statuses, not from a cached key.
        localStorage.setItem('managers', JSON.stringify(managersData));
      } else if (response.status === 404) {
          // setModalMessage("Management structure not found for this entity, You can add a new one.")
          // setIsModalOpen(true);
      } else {
        console.error("Failed to fetch management structure data:", response.data);
      }
    } catch (error) {
      console.error("Error fetching management structure details:", error);
    }
  },[]);

  useEffect(()=>{
    if (isView || isEdit) {
      getManagementStrcutureDetails(sharedData.get("entityId"));
    } else {
      // if not present in localstorage, call from api
      const storedManagers = localStorage.getItem('managers');
      if (!storedManagers) {
        getManagementStrcutureDetails(sharedData.get("entityId"));
      }
    }
  },[getManagementStrcutureDetails, isView, isEdit]);




  const fetchRiskAssessment = async (entityId) => {
    try {
      const token = userSession.getToken();
      console.log("🔄 Fetching risk assessment for Entity ID:", entityId);
  
      const response = await fetch(`${config["backend-url"]}/get_risk_assessment`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ entityId })  // ✅ entityId sent in request body
      });
  
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || "Failed to fetch risk assessment");
      }
  
      const riskData = await response.json();
  
      // ✅ Store in localStorage
      localStorage.setItem("riskFormData", JSON.stringify(riskData));
      console.log("✅ Risk assessment data saved to localStorage:", riskData);
     
  
      return riskData;
  
    } catch (error) {
      console.error("❌ Error fetching risk assessment:", error.message);
    }
  };

  useEffect(() => {
    const entityId = sharedData.get("entityId");
  
    if (entityId && entityId !== "None") {
      (async () => {
        await fetchRiskAssessment(entityId);
      })();
    }
  }, []); // You can add dependencies like [sharedData] if needed














  const getMergedUpdatedDocs = async () => {
    const mergedData = {};
    const { entityId, requestId, email } = getStoredValues(); // Assumes this returns valid requestId and email
    const currentPage = location.pathname.replace("/", ""); // Remove leading slash

    try {
      const res = await fetch(
        `${config["backend-url"]}/get-required?page=${currentPage}&requestId=${requestId}&email=${email}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${userSession.getToken()}`, // Use token from userSession
          }
        }
      );

      if (res.ok) {
        const data = await res.json();
        Object.assign(mergedData, data); // merge fetched data
        console.log("mergedData in res:", mergedData);
      } else {
        console.warn("Failed to fetch required docs");
      }
    } catch (err) {
      console.error("Error fetching required docs:", err);
    }

    // ✅ Always set mergedData in localStorage, even if it's still {}
    const finalPageKey = "updatedDocs-/FinalReview";
    localStorage.setItem(finalPageKey, JSON.stringify(mergedData));

    return mergedData;
  };

  const checkFinalizeAvailability = (statuses) => {
    // Transaction/Property may legitimately not exist for a request.
    const validStatuses = ["validated", "n/a", "not available", "not applicable"];

    if (!(requiredDocumentsAttached === true && pagesValidated === "Yes")) {
      return false;
    }

    const getStatus = (s) => (s || "").toLowerCase();

    const isEnhanced = getStatus(statuses.diligence_status) === "enhanced";
    const eddOk = isEnhanced
      ? getStatus(statuses.edd_status) === "validated"
      : true;

    // Corporate Structure / Management Structure pass on a real sign-off, or on the
    // backend-derived "Not Applicable" (Simplified diligence, section holds no data) —
    // and on nothing else. No diligence check here: the backend already decided
    // applicability, and a Simplified section that holds data must be validated too.
    const sectionOk = (s) => ["validated", "not applicable"].includes(getStatus(s));

    const isFinalizable =
      validStatuses.includes(getStatus(statuses.transaction_status)) &&
      validStatuses.includes(getStatus(statuses.property_status)) &&
      getStatus(statuses.entity_status) === "validated" &&
      sectionOk(statuses.corporate_structure_status) &&
      sectionOk(statuses.management_data_status) &&
      getStatus(statuses.risk_assessment_status) === "validated" &&
      eddOk;

    return isFinalizable;
  };

  useEffect(() => {
    const fetchUserStatus = async () => {
      const token = userSession.getToken()
      try {
        
        const response = await fetch(`${config["backend-url"]}/get_user_Status_Flag`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        if (response.ok) {
          setMLNOFlag(data.MLNOFag);
        }
      } catch (error) {
        console.error("Error fetching MLNO flag:", error);
      }
    };
    fetchUserStatus();
  }, []);






  const checkIsReadOnly = (status) => {
    const isEditMode = searchParams.get("edit") === "true";
    const isTransactionCompleted = status === "Validated";
    const isReadOnlyFromURL = searchParams.get("readonly") === "true";
    const isViewMode = searchParams.get("view") === "true";
    return isTransactionCompleted || isReadOnlyFromURL || isViewMode;
  };
  
  
  

  useEffect(() => {
    const initFinalReview = async () => {
      const sharedData = JSON.parse(localStorage.getItem("sharedData")) || {};
      const request_id = sharedData?.requestId;
      if (!request_id) return;

      setRequestId(request_id);

      try {
        const finalReviewResp = await fetch(`${config["backend-url"]}/get_final_review_info`, {
          method: "POST",
          headers: { "Content-Type": "application/json",
            "Authorization": `Bearer ${userSession.getToken()}`  // Ensure token is included
           },
          body: JSON.stringify({ request_id })
        });

        if (finalReviewResp.ok) {
          const reviewData = await finalReviewResp.json();
          setfinalReviewInfo(reviewData);
        }

        // const statusTypeResp = await fetch(`${config["backend-url"]}/get-request-status-type`, {
        //   method: "POST",
        //   headers: { "Content-Type": "application/json" },
        //   body: JSON.stringify({ request_id })
        // });

        // if (statusTypeResp.ok) {
          
        //   const text = await statusTypeResp.text();
        //   if (text) {
        //     console.log("Response text:", text);
        //     const statusData = JSON.parse(text);
        //     const level = statusData.RequestStatus_Type || "Not Available";
        //     console.log("Request Status Type:", level);
        //     setRequestStatus(statusData.Request_Status || "Not Available");
           
        //     console.log("Request Status:", requestStatus);
        //     // optional: set a diligenceLevel here if needed
        //   }
        // }



        const statusTypeResp = await fetch(`${config["backend-url"]}/get-request-status-type`, {
          method: "POST",
          headers: { "Content-Type": "application/json",
            "Authorization": `Bearer ${userSession.getToken()}`  // Ensure token is included
           },
          body: JSON.stringify({ request_id })
        });
        
        if (statusTypeResp.ok) {
          const text = await statusTypeResp.text();
          if (text) {
            console.log("Response text:", text);
            const statusData = JSON.parse(text);
            
            const level = statusData.RequestStatus_Type || "Not Available";
            setRequestStatusType(level);
            console.log("Request Status Type:", level);
        
            // ✅ Corrected line:
            setRequestStatus(statusData.Request_Status || "Not Available");
        
            console.log("Request Status:", statusData.Request_Status);
          }
        }
        const statusesResp = await fetch(`${config["backend-url"]}/get-all-statuses`, {
          method: "POST",
          headers: { "Content-Type": "application/json",
            "Authorization": `Bearer ${userSession.getToken()}`  // Ensure token is included
           },
          body: JSON.stringify({ request_id })
        });

        if (statusesResp.ok) {
          const result = await statusesResp.json();
          // Use the server's statuses as they are. It returns "Not Applicable" for
          // Corporate/Management when Simplified diligence skips them; overriding them
          // to "Validated" here used to make the UI disagree with the sign-off gate and
          // with the report.
          const serverStatuses = result.statuses || {};
          setStatuses(serverStatuses);
          const ready = checkFinalizeAvailability(serverStatuses);
          setCanFinalize(ready);
        }

        const updatedDocs = await getMergedUpdatedDocs();
        // const updatedKeys = Object.keys(updatedDocs).filter(
        //   (key) => !key.startsWith("transaction-detail")
        // );

        const updatedKeys = Object.keys(updatedDocs).filter(
          (key) => !key.includes("Optional")  // ✅ Updated condition
        );
        const loadedDocKeys = await getLoadedDocKeys();
        console.log("loadedDocKeys:",loadedDocKeys)
        const allPresent = updatedKeys.every(key => loadedDocKeys.includes(key));
        setRequiredDocumentsAttached(allPresent);
      } catch (err) {
        console.warn("⚠️ Error initializing final review:", err.message);
      }
    };

    initFinalReview();
  }, [refreshDocs]);

  useEffect(() => {
    const fetchMLNOData = async () => {
      try {
        const response = await fetch(`${config["backend-url"]}/get_mlno_by_request`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({ requestId })
        });

        if (!response.ok) throw new Error("Failed to fetch MLNO data");

        const data = await response.json();
        if (data.mlno) {
          setSignature(data.mlno.Signature || "");
          setFormData(prev => ({
            ...prev,
            justification: data.mlno.Justification || "",
            MLNOCOnsideration: data.mlno.MLNOConsideration || "",
            mlnoComments: data.mlno.MLNOComments || "",
            signature: data.mlno.Signature || "",
            status: data.mlno.Status || ""
          }));

          const isReadOnlyFromURL = searchParams.get("readonly") === "true" || searchParams.get("view") === "true";

          if (data.mlno.Status === "Validated") {
            // Only lock the page if the request itself is complete.
            // If the request is still "Pending MLNO", the MLNO needs to
            // be able to click "Validate & Complete" to finish the flow.
            // Always honour ?view/?readonly URL params even when the MLNO
            // is mid-flow.
            const reqStatus = (requestStatus || "").toLowerCase();
            const isRequestDone = ["complete", "completed"].includes(reqStatus);
            setIsReadOnly(isRequestDone || isReadOnlyFromURL);

            console.log("MLNO Status is Validated, request done:", isRequestDone, "URL readonly:", isReadOnlyFromURL);

          }
          else  {
            setIsReadOnly(isReadOnlyFromURL);

            console.log("MLNO Status is not Validated, read-only from URL:", isReadOnlyFromURL);

          }

          setIsChecked(data.mlno.Status === "Validated");
          setShowSignatureContainer(true);
        }
      } catch (error) {
        console.error("❌ Error fetching MLNO data:", error);
      }
    };

    if (requestId) {
      fetchMLNOData();
    }
  }, [requestId, requestStatus]);

  return {
    requestId,
    statuses,
    canFinalize,
    signature,
    uploadedSignature,
    setUploadedSignature,
    showSignatureContainer,
    isChecked,
    setIsChecked,
    setCanFinalize,
    modalMessage,
    setModalMessage,
    isEmailModalOpen,
    setStatuses,
    setShowSignatureContainer,
    checkIsReadOnly,
    isReadOnly,
    isAllValidated,
    canFinalize,
    setRequestStatus,
    requestStatus,
    setIsEmailModalOpen,
    setRequiredDocumentsAttached,
    checkFinalizeAvailability ,
    formData,
    setRequestStatusType,

    requsetStatusType,
    setFormData,
    diligenceLevel,
    setSignature,
    finalReviewInfo,
    MLNOFlag,
    requiredDocumentsAttached,
    setRefreshDocs
  };
};
